import { AppNotification } from "@notifications/Notification";
import { useEffect } from "react";
import { useSearchParams } from "react-router";

const useAffiliationCode = (
  handleChangeAffiliationCode: (code: string) => void,
) => {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const affiliationCode = searchParams.get("ref");

    if (affiliationCode) {
      handleChangeAffiliationCode(affiliationCode);
      AppNotification.default({
        title: "Code de Parrainage",
        message: `Vous profitez du code de ${affiliationCode}. Bonne journée sur Secret Smurfs`,
      });
      setSearchParams({}, { replace: true });
    }
  }, [searchParams, setSearchParams, handleChangeAffiliationCode]);
};

export default useAffiliationCode;
